export default __webpack_public_path__ + "static/mobile-bg-elevating-48b463eaa5a6d95d23faa3c9e93a61ec.png";